import PropTypes from 'prop-types';
import Spinner from '../../atoms/Spinner/Spinner';
import styles from './CommonSuspenseLoader.module.css';

/**
 * CommonSuspenseLoader - A full-screen loader component for React Suspense
 *
 * This component provides a high z-index overlay with a centered spinner,
 * designed to be used as a fallback UI for React Suspense while lazy loading components.
 */
const CommonSuspenseLoader = ({ className = '' }) => {
  return (
    <div className={`${styles.suspenseLoader} ${className}`}>
      <div className={styles.suspenseLoader__content}>
        <Spinner />
      </div>
    </div>
  );
};

CommonSuspenseLoader.propTypes = {
  className: PropTypes.string,
};

export default CommonSuspenseLoader;
